import { useThemeContext } from './useThemeContext';
export function useStyleSheet(styles) {
    const { colorScheme } = useThemeContext();
    return styles[colorScheme];
}
//# sourceMappingURL=useStyleSheet.js.map